(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-download-pdf"] && !Shopify.designMode) return;
  try {
    class HdtDownloadProductPdf extends HTMLElement {
  static get observedAttributes() {
    return [
      'targets','exclude','filename','page','landscape',
      'margin','scale','usecors','removebackground',
      'disablesticky','bgcolor','imageformat'
    ];
  }

  constructor() {
    super();
    this._onClick = this._onClick.bind(this);
  }

  connectedCallback() { this.addEventListener('click', this._onClick); }
  disconnectedCallback() { this.removeEventListener('click', this._onClick); }

  async _printPDF() {
    const exportDiv = document.querySelector('.hdt-export-pdf-main');
    if (!exportDiv) throw new Error('Plantilla de exportación no encontrada');

    exportDiv.querySelectorAll('[data-clone_selector]').forEach(holder => {
      const sel = holder.getAttribute('data-clone_selector');
      if (!sel) return;
      holder.innerHTML = '';
      document.querySelectorAll(sel).forEach(el => holder.appendChild(el.cloneNode(true)));
    });

    const originalParent = exportDiv.parentElement;
    const originalNext = exportDiv.nextSibling;
    exportDiv.classList.remove('hdt-hidden');
    exportDiv.style.display = 'block';
    document.body.appendChild(exportDiv);

    const imgs = Array.from(exportDiv.querySelectorAll('img'));
    if (imgs.length) {
      await Promise.race([
        Promise.all(imgs.map(img => new Promise(res => {
          if (img.complete && img.naturalWidth > 0) return res();
          img.addEventListener('load', res, { once: true });
          img.addEventListener('error', res, { once: true });
        }))),
        new Promise(r => setTimeout(r, 3000))
      ]);
    }

    const style = document.createElement('style');
    style.id = 'hdt-print-pdf-style';
    style.textContent = '@media print { @page { size: A4 portrait; margin: 0; } body > *:not(.hdt-export-pdf-main) { display: none !important; } .hdt-export-pdf-main { display: block !important; width: 210mm; min-height: 0 !important; background: #fff; } }';
    document.head.appendChild(style);

    window.print();

    setTimeout(() => {
      exportDiv.classList.add('hdt-hidden');
      exportDiv.style.display = '';
      if (originalNext) { originalParent.insertBefore(exportDiv, originalNext); }
      else { originalParent.appendChild(exportDiv); }
      const s = document.getElementById('hdt-print-pdf-style');
      if (s) s.remove();
    }, 1000);
  }

  async _loadLibraries() {
    const libs = (window.themeHDN && window.themeHDN.pdfLibs) || {};
    const load = (src) => new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) { resolve(); return; }
      const s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = () => reject(new Error('No se pudo cargar: ' + src));
      document.head.appendChild(s);
    });
    const pending = [];
    if (!window.html2canvas) {
      pending.push(load(libs.html2canvas || 'https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js'));
    }
    if (!(window.jspdf && window.jspdf.jsPDF)) {
      pending.push(load(libs.jsPDF || 'https://cdn.jsdelivr.net/npm/jspdf@2.5.1/dist/jspdf.umd.min.js'));
    }
    if (pending.length) await Promise.all(pending);
  }

  _parseSelectors(attr) {
    const raw = (this.getAttribute(attr) || '').trim();
    if (!raw) return [];
    return raw.split(',').map(s => s.trim()).filter(Boolean);
  }

  _normalizeLazyMedia(root) {
    root.querySelectorAll('picture source').forEach(src => {
      const dss = src.getAttribute('data-srcset') || src.getAttribute('data-lazy-srcset') || src.getAttribute('data-src');
      if (dss) src.setAttribute('srcset', dss);
    });
    root.querySelectorAll('img').forEach(img => {
      const lazySrc = img.getAttribute('data-src') || img.getAttribute('data-original') || img.getAttribute('data-lazy-src');
      const lazySrcset = img.getAttribute('data-srcset') || img.getAttribute('data-lazy-srcset');
      if (lazySrc) img.setAttribute('src', lazySrc);
      if (lazySrcset) img.setAttribute('srcset', lazySrcset);
      img.setAttribute('loading','eager');
      img.setAttribute('decoding','sync');
      img.setAttribute('fetchpriority','high');
      if (!img.getAttribute('crossorigin')) img.setAttribute('crossorigin','anonymous');
      img.style.setProperty('max-width','100%');
      img.style.setProperty('height','auto');
      img.style.setProperty('display','block');
      img.style.setProperty('opacity','1');
      img.style.setProperty('visibility','visible');
    });
  }

  async _waitImages(root) {
    const imgs = Array.from(root.querySelectorAll('img'));
    if (!imgs.length) return;
    imgs.forEach(img => {
      const lazySrc = img.getAttribute('data-src') || img.getAttribute('data-original') || img.getAttribute('data-lazy-src');
      const lazySrcset = img.getAttribute('data-srcset') || img.getAttribute('data-lazy-srcset');
      if (lazySrc) img.setAttribute('src', lazySrc);
      if (lazySrcset) img.setAttribute('srcset', lazySrcset);
      img.setAttribute('loading', 'eager');
      if (!img.getAttribute('crossorigin')) img.setAttribute('crossorigin', 'anonymous');
    });
    const timeout = new Promise(r => setTimeout(r, 3000));
    await Promise.race([
      Promise.all(imgs.map(img => new Promise(res => {
        if (img.complete) return res();
        const done = () => res();
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      }))),
      timeout
    ]);
  }

  _pruneExclusions(root, extraSelectors) {
    const builtIn = ['hdt-download-product-pdf','.pdf-exclude','[data-pdf-exclude]'];
    const selectors = builtIn.concat(extraSelectors || []);
    if (!selectors.length) return;
    root.querySelectorAll(selectors.join(',')).forEach(n => n.remove());
  }

  _disableSticky(root, selectors) {
    const defaults = ['.hdt-group-product-block','.hdt-product-media-wrapps','.hdt-product-info__list'];
    const list = (selectors && selectors.length) ? selectors : defaults;
    root.querySelectorAll(list.join(',')).forEach(el => {
      el.style.position = 'static';
      el.style.top = 'auto';
      el.style.bottom = 'auto';
      el.style.left = 'auto';
      el.style.right = 'auto';
    });
  }

  _disableProblematicComponents() {
    const problematicSelectors = [
      'hdt-predictive-search',
      'hdt-wishlist-a',
      'hdt-compare-a',
      'hdt-quick-search',
      'hdt-product-recommendations',
      'hdt-product-recently',
      'hdt-back-to-top',
      'hdt-cookies-bar'
    ];

    problematicSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        el.style.display = 'none';
        el.setAttribute('data-pdf-disabled', 'true');
      });
    });
  }

  _enableProblematicComponents() {
    document.querySelectorAll('[data-pdf-disabled="true"]').forEach(el => {
      el.style.display = '';
      el.removeAttribute('data-pdf-disabled');
    });
  }

  _expandProductMedia(container) {
    const medias = container.querySelectorAll('.hdt-product-media__main');
    if (!medias.length) return;

    medias.forEach(media => {
      const viewport = media.querySelector('.hdt-slider__viewport');
      const track = media.querySelector('.hdt-slider__container');
      const slides = media.querySelectorAll('.hdt-slider__slide');

      slides.forEach((s, i) => {
        if (i === 0) {
          if (s.hasAttribute('hidden')) s.removeAttribute('hidden');
          s.style.removeProperty('transform');
          s.style.removeProperty('position');
          s.style.removeProperty('left');
          s.style.removeProperty('right');
          s.style.removeProperty('top');
          s.style.removeProperty('bottom');
          s.style.setProperty('display','block','important');
          s.style.setProperty('width','auto','important');
          s.style.setProperty('height','auto','important');
        } else {
          s.style.setProperty('display','none','important');
        }
      });
      if (viewport) {
        viewport.style.setProperty('overflow','visible','important');
        viewport.style.setProperty('height','auto','important');
      }
      if (track) {
        track.style.removeProperty('transform');
        track.style.setProperty('display','block','important');
        track.style.setProperty('width','auto','important');
      }
      media.classList.remove('is--enabled');
    });
  }

  _expandProductDescription(container) {
    const descriptions = container.querySelectorAll('.hdt-product-description, .hdt-rte, .hdt-product-tabs__content, .hdt-group-product-block');

    descriptions.forEach(desc => {
      desc.style.height = 'auto';
      desc.style.maxHeight = 'none';
      desc.style.minHeight = 'auto';
      desc.style.overflow = 'visible';

      const content = desc.querySelector('.hdt-product-tabs__panel, .hdt-rte, .hdt-product-description');
      if (content) {
        content.style.height = 'auto';
        content.style.maxHeight = 'none';
        content.style.overflow = 'visible';
        content.style.display = 'block';
      }

      const accordions = desc.querySelectorAll('details, .hdt-accordion');
      accordions.forEach(accordion => {
        accordion.open = true;
        accordion.setAttribute('open', '');
      });

      const hiddenElements = desc.querySelectorAll('[hidden], .hdt-hidden');
      hiddenElements.forEach(el => {
        const isStockElement = el.closest('.hdt-product-stock, .hdt-stock-options, .hdt-variant-selector, .hdt-product-form__options') ||
                              el.classList.contains('hdt-stock-option') ||
                              el.querySelector('.hdt-stock-option') ||
                              el.textContent.includes('Stock bajo') ||
                              el.textContent.includes('En stock') ||
                              el.textContent.includes('Agotado') ||
                              el.textContent.includes('Preordenar');

        if (!isStockElement) {
          el.removeAttribute('hidden');
          el.classList.remove('hdt-hidden');
          el.style.display = 'block';
        }
      });
    });
  }

  _hideStockOptions(container) {
    const stockSelectors = [
      '.hdt-product-stock',
      '.hdt-stock-options',
      '.hdt-variant-selector',
      '.hdt-product-form__options',
      '[data-stock-option]',
      '.hdt-stock-option'
    ];

    stockSelectors.forEach(selector => {
      container.querySelectorAll(selector).forEach(el => {
        const text = el.textContent.toLowerCase();
        if (text.includes('stock bajo') ||
            text.includes('en stock') ||
            text.includes('agotado') ||
            text.includes('preordenar') ||
            text.includes('restantes')) {
          el.style.display = 'none';
          el.setAttribute('data-pdf-hidden', 'true');
        }
      });
    });
  }

  _optimizeTagsForPDF(container) {
    const tagSelectors = [
      '.hdt-tag-list',
      '.hdt-product-tags',
      '.hdt-badge',
      '.hdt-tag',
      '.hdt-label'
    ];

    tagSelectors.forEach(selector => {
      container.querySelectorAll(selector).forEach(tagContainer => {
        tagContainer.style.display = 'flex';
        tagContainer.style.flexWrap = 'wrap';
        tagContainer.style.gap = '8px';
        tagContainer.style.margin = '10px 0';

        const tags = tagContainer.querySelectorAll('li, .hdt-badge, .hdt-tag, .hdt-label');
        tags.forEach(tag => {
          tag.style.display = 'inline-block';
          tag.style.padding = '4px 8px';
          tag.style.margin = '2px';
          tag.style.backgroundColor = '#f0f0f0';
          tag.style.color = '#333';
          tag.style.border = '1px solid #ddd';
          tag.style.borderRadius = '4px';
          tag.style.fontSize = '12px';
          tag.style.fontWeight = '500';
          tag.style.textDecoration = 'none';
          tag.style.whiteSpace = 'nowrap';

          const text = tag.textContent.toLowerCase();
          if (text.includes('reba') || text.includes('descuento') || text.includes('off') || text.includes('%')) {
            tag.style.backgroundColor = '#dc3545';
            tag.style.color = 'white';
            tag.style.borderColor = '#dc3545';
            tag.style.fontWeight = 'bold';
          } else if (text.includes('stock') || text.includes('disponible')) {
            tag.style.backgroundColor = '#28a745';
            tag.style.color = 'white';
            tag.style.borderColor = '#28a745';
          } else if (text.includes('agotado') || text.includes('out of stock')) {
            tag.style.backgroundColor = '#6c757d';
            tag.style.color = 'white';
            tag.style.borderColor = '#6c757d';
          }
        });
      });
    });
  }

  _prepareExportWrapper(uniqueNodes, bgColor) {
    const wrapper = document.createElement('div');
    wrapper.style.background = bgColor || '#ffffff';

    wrapper.classList.add('hdt-pdf-export-mode');

    wrapper.setAttribute('data-pdf-export', 'true');

    let exportMain = document.querySelector('.hdt-export-pdf-main');
    if (exportMain) {
      exportMain = exportMain.cloneNode(true);
    } else {
      exportMain = document.createElement('div');
      exportMain.className = 'hdt-hidden hdt-export-pdf-main hdt-product-export-pdf';
      exportMain.setAttribute('aria-hidden','true');
      exportMain.innerHTML = `
        <div class="hdt-export-pdf-main-container">
          <div class="hdt-pdf-exp-part hdt-pdf-exp-part--left">
            <div class="hdt-product-media__main--clone hdt-pdf-exp-holder" data-clone_selector=".hdt-product-media__main"></div>
          </div>
          <div class="hdt-pdf-exp-part hdt-pdf-exp-part--right">
            <div class="hdt-group-product-block--clone hdt-pdf-exp-holder" data-clone_selector=".hdt-group-product-block"></div>
            <div class="hdt-product-tabs--clone hdt-pdf-exp-holder" data-clone_selector=".hdt-product-tabs"></div>
          </div>
        </div>
      `;
    }

    exportMain.classList.add('hdt-pdf-export-mode');

    exportMain.style.display = 'block';
    exportMain.style.background = bgColor || '#ffffff';

    exportMain.querySelectorAll('.hdt-pdf-exp-holder').forEach(holder => {
      holder.innerHTML = '';
      const sel = holder.getAttribute('data-clone_selector');
      if (sel) {
        document.querySelectorAll(sel).forEach(el => {
          const c = el.cloneNode(true);
          c.style.background = bgColor || '#ffffff';
          c.classList.add('hdt-pdf-export-mode');
          this._normalizeLazyMedia(c);
          holder.appendChild(c);
        });
      }
    });

    this._expandProductMedia(exportMain);
    this._expandProductDescription(exportMain);
    this._hideStockOptions(exportMain);
    this._optimizeTagsForPDF(exportMain);
    this._normalizeLazyMedia(exportMain)
    wrapper.appendChild(exportMain);

    uniqueNodes.forEach(node => {
      if (node.classList && node.classList.contains('hdt-export-pdf-main')) return;
      const c = node.cloneNode(true);
      c.style.background = bgColor || '#ffffff';
      c.classList.add('hdt-pdf-export-mode');
      this._expandProductDescription(c);
      this._hideStockOptions(c);
      this._optimizeTagsForPDF(c);
      this._normalizeLazyMedia(c);
      wrapper.appendChild(c);
    });

    return wrapper;
  }

  _canvasToPDF(canvas, pdf, opts) {
    const { bgColor = '#ffffff', imgType = 'JPEG' } = opts;
    const margin = Math.max(0, opts.marginMm || 12);
    const pdfW = pdf.internal.pageSize.getWidth();
    const pdfH = pdf.internal.pageSize.getHeight();
    const contentWmm = pdfW - margin*2;
    const contentHmm = pdfH - margin*2;
    const mm = (px)=>px*25.4/96;
    const px = (mmVal)=>mmVal*96/25.4;

    const cw = canvas.width, ch = canvas.height;
    const targetWpx = px(contentWmm);
    const scaleFactor = targetWpx/cw;
    const pageHpx = px(contentHmm)/scaleFactor;

    const pageCanvas = document.createElement('canvas');
    const ctx = pageCanvas.getContext('2d');

    const pages = Math.max(1, Math.ceil(ch / pageHpx));
    for (let i=0;i<pages;i++) {
      const sy = Math.floor(i * pageHpx);
      const sh = Math.min(pageHpx, ch - sy);

      pageCanvas.width = cw;
      pageCanvas.height = Math.max(1, Math.floor(sh));
      ctx.save();
      ctx.fillStyle = bgColor;
      ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
      ctx.drawImage(canvas, 0, sy, cw, sh, 0, 0, cw, sh);
      ctx.restore();

      const mime = imgType.toUpperCase() === 'PNG' ? 'image/png' : 'image/jpeg';
      const quality = mime === 'image/jpeg' ? 0.75 : undefined;
      const imgData = pageCanvas.toDataURL(mime, quality);

      if (i>0) pdf.addPage({ orientation: opts.orientation, format: opts.pageFormat });

      const sliceHmm = (sh * scaleFactor) * 25.4 / 96;
      const drawHmm = Math.min(sliceHmm, contentHmm);
      pdf.addImage(imgData, imgType.toUpperCase(), margin, margin, contentWmm, drawHmm, undefined, 'FAST');
    }
  }

  async _exportToPDF({targets,excludeSelectors,filename,page,landscape,marginMm,scale,useCORS,disableStickySelectors,bgColor,imgType,removeBg}) {
    if (!window.html2canvas || !(window.jspdf && window.jspdf.jsPDF)) throw new Error('Libraries missing');

    window.HDT_PDF_EXPORT_MODE = true;

    this._disableProblematicComponents();

    const nodes = (targets||[]).flatMap(sel => Array.from(document.querySelectorAll(sel)));
    const uniqueNodes = Array.from(new Set(nodes));
    if (!uniqueNodes.length) throw new Error('No targets found');

    const holder = document.createElement('div');
    holder.setAttribute('aria-hidden','true');
    holder.style.position='fixed';
    holder.style.left='-100000px';
    holder.style.top='0';
    holder.style.zIndex='-1';
    holder.style.background = bgColor || '#ffffff';

    const base = uniqueNodes[0];
    const baseRect = base.getBoundingClientRect();

    const wrapper = this._prepareExportWrapper(uniqueNodes, bgColor);
    wrapper.style.width = Math.min(baseRect.width||base.offsetWidth||800, 900)+'px';

    this._pruneExclusions(wrapper, excludeSelectors);
    this._disableSticky(wrapper, disableStickySelectors);

    holder.appendChild(wrapper);
    document.body.appendChild(holder);

    try {
      await this._waitImages(wrapper);
      await new Promise(r => setTimeout(r, 50));
      const h2cBg = (removeBg && (bgColor === 'transparent' || bgColor === '')) ? null : (bgColor || '#ffffff');

      const canvas=await window.html2canvas(wrapper,{
        scale: 1,
        useCORS:!!useCORS,
        allowTaint:false,
        backgroundColor: h2cBg,
        logging:false,
        imageTimeout: 5000
      });

      const {jsPDF}=window.jspdf;
      const orientation=landscape?'landscape':'portrait';
      const pdf=new jsPDF({orientation,unit:'mm',format:page||'a4'});

      this._canvasToPDF(canvas,pdf,{
        marginMm:marginMm??12,
        orientation,
        pageFormat:page||'a4',
        bgColor: (h2cBg === null ? '#ffffff' : h2cBg) || '#ffffff',
        imgType: (imgType || 'JPEG')
      });

      pdf.save(filename||'download.pdf');
    } finally {
      window.HDT_PDF_EXPORT_MODE = false;

      this._enableProblematicComponents();

      holder.remove();
    }
  }

  async _onClick(e) {
    const btn = (e.target && e.target.closest('button')) || this;
    const hasBtnState = ('disabled' in btn)&&('textContent' in btn);
    const prevDisabled = hasBtnState?btn.disabled:undefined;
    const prevHTML = hasBtnState?btn.innerHTML:undefined;
    try {
      if(hasBtnState){
        btn.disabled=true;
        btn.style.position = 'relative';
        btn.style.overflow = 'visible';
        btn.innerHTML = btn.innerHTML + '<div class="loading-ring" style="position: absolute; top: 50%; left: 50%; width: 56px; height: 56px; border: 2px solid rgba(36,88,141,0.1); border-top: 2px solid rgba(36,88,141,0.6); border-radius: 50%; pointer-events: none; transform: translate(-50%, -50%);"></div>';
        if(!document.querySelector('#loading-spinner-style')){
          const style = document.createElement('style');
          style.id = 'loading-spinner-style';
          style.textContent = '@keyframes spin { from { transform: translate(-50%, -50%) rotate(0deg); } to { transform: translate(-50%, -50%) rotate(360deg); } } .loading-ring { animation: spin 1s linear infinite !important; }';
          document.head.appendChild(style);
        }
      }
      await this._printPDF();
    } catch(err) {
      alert('Error al generar la ficha técnica: '+(err?.message||err));
    } finally {
      if(hasBtnState){
        btn.disabled=prevDisabled;
        btn.style.position = '';
        btn.style.overflow = '';
        const loadingRing = btn.querySelector('.loading-ring');
        if(loadingRing) loadingRing.remove();
        if(prevHTML) btn.innerHTML=prevHTML;
      }
    }
  }
}

if (!customElements.get('hdt-download-product-pdf')) {
  customElements.define('hdt-download-product-pdf', HdtDownloadProductPdf);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-variant-picker"] && !Shopify.designMode) return;
  try {
    function startPdpFirstSwatch() {
  if (!window.location.pathname.includes('/products/')) return;

  function activateFirstSwatch() {
    const firstInput = document.querySelector(
      'fieldset.hdt-product-form__input.is-style-color input[type="radio"]'
    );
    if (!firstInput) return false;

    firstInput.checked = true;
    firstInput.dispatchEvent(new Event('change', { bubbles: true }));
    firstInput.dispatchEvent(new Event('input', { bubbles: true }));
    firstInput.closest('label, .hdt-product-form-value')?.click();
    return true;
  }

  if (activateFirstSwatch()) return;

  let done = false;
  const swatchObserver = new MutationObserver(() => {
    if (done || !activateFirstSwatch()) return;
    done = true;
    swatchObserver.disconnect();
  });

  swatchObserver.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => {
    done = true;
    swatchObserver.disconnect();
  }, 3000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startPdpFirstSwatch, { once: true });
} else {
  startPdpFirstSwatch();
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product_complimentary"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.hdt-product__complimentary-item').forEach((item) => {
  const titleLink = item.querySelector('.hdt-card-product__title:not(a .hdt-card-product__title)');
  const readMoreButton = item.querySelector('.hdt-button-read_more');

  if (titleLink && readMoreButton && !readMoreButton.getAttribute('href')) {
    readMoreButton.setAttribute('href', titleLink.href);
  }
});
  } catch(e) { console.error(e); }
})();

})();
